module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch01"
    }
  }, [_vm._v("History on a Personal Note")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02"
    }
  }, [_vm._v("For Widgit Stands")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Money Honey")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith Is a Girl’s Name")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Beginning")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carlotta")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Halfway to Farmville")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Houses")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Courtship")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jewish but Not Really")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Zen of Driving")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Viewing Stacy from Above")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exclusive Pleasures")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Full Life of a Different Nature")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cape Man")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rural Delivery")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ata#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "rev_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/praise#rev01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "adc_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adc#adc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by Binnie Kirshenbaum")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copy#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/atp#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0